import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { FranchisorAgencies } from '@/javascript/interfaces'
import type { ErrorType } from '@/javascript/interfaces'

import api from '../services/api'
import { postAgencyStats } from '../services/franchisor'
import { useNotificationStore } from './NotificationStore'

export const useFranchisorStore = defineStore('franchisor', () => {
	// State
	const complianceReportLastPrintedAtCompleted = ref('')
	const complianceReportLastPrintedAtIncomplete = ref('')
	const courseStatusCompleted = ref('')
	const courseStatusIncomplete = ref('')
	const franchisorAgencies = ref([] as FranchisorAgencies[])
	const franchisorId = ref(null as number | null)
	const franchisorName = ref('')
	const hasErrors = ref(false)
	const loadingFranchisorAgencies = ref(true)
	const notificationStore = useNotificationStore()
	const printComplianceReportFranchisorPathUrl = ref('')
	const sinceAccountCreatedAt = ref('')

	// Actions
	const loadFranchisorAgencies = async () => {
		try {
			const response: FranchisorAgencies[] = await postAgencyStats(api, { franchisor_id: franchisorId.value })

			franchisorAgencies.value = response
		} catch (error) {
			notificationStore.onHandleErrorMessages({ error: error as ErrorType })
			hasErrors.value = true
		} finally {
			loadingFranchisorAgencies.value = false
		}
	}

	const resetData = () => {
		franchisorName.value = ''
	}

	return {
		complianceReportLastPrintedAtCompleted,
		complianceReportLastPrintedAtIncomplete,
		courseStatusCompleted,
		courseStatusIncomplete,
		franchisorAgencies,
		franchisorId,
		franchisorName,
		hasErrors,
		loadingFranchisorAgencies,
		printComplianceReportFranchisorPathUrl,
		sinceAccountCreatedAt,
		loadFranchisorAgencies,
		resetData,
	}
})
